import React from "react";
import { Grid, Typography, Box } from "@mui/material";

const SummaryRow = ({ label, value }) => {
  return (
    <Grid
      container
      sx={{
        borderBottom: "1px solid #e0e0e0",
        py: 2,
        alignItems: "center",
        width: { xs: "100%", md: "70%" },
      }}
    >
      {/* Nome campo */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          color: "#777",
          fontSize: "15px",
        }}
      >
        {label}
      </Grid>

      {/* Valore */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          textAlign: { xs: "left", md: "right" },
          fontSize: "15px",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#333" }}>
          {value || "-"}
        </Typography>
      </Grid>
    </Grid>
  );
};

const Step_6_Delegation = ({ formDataYousign, delegation }) => {
  return (
    <Grid container>
      <Grid item xs={12} className="container-steps">
        <Typography className="title-steps">
          Avvio del processo di firma elettronica
        </Typography>

        <Typography
          className="text-steps"
          component="div"
          sx={{ mt: 1, mb: 3 }}
        >
          Per procedere con la firma elettronica devi avere a disposizione:
          <ul style={{ padding: "0px 0px 0px 16px", marginTop: "5px" }}>
            <li>
              il tuo <span style={{ fontWeight: "bold" }}>smartphone</span>
            </li>
            <li>
              foto a colori in alta qualità, senza ritagli, del tuo{" "}
              <span style={{ fontWeight: "bold" }}>documento di identità</span>
            </li>
          </ul>
        </Typography>

        <Typography
          className="text-steps"
          component="div"
          sx={{ mt: 1, mb: 1 }}
        >
          Contatti che verranno utilizzati per la firma, da te confermati in
          precedenza:
        </Typography>

        <Grid item xs={12} sm={8} md={6}>
          <SummaryRow label="Nome" value={formDataYousign.name} />

          <SummaryRow label="Cognome" value={formDataYousign.lastname} />

          <SummaryRow
            label="Numero di cellulare"
            value={delegation.telephone}
          />

          <SummaryRow label="Email" value={delegation.email} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Step_6_Delegation;
